export default __webpack_public_path__ + "static/media/KidcoGrillGuide1.b78cb531.jpg";